import styled from "styled-components";

const toCssSize = (value, fallbackPx) => {
  if (value === undefined || value === null) return `${fallbackPx}px`;
  if (typeof value === "number") return `${value}px`;
  return value;
};

export const Container = styled.div`
  display: ${(props) => (props.show ? "inline-flex" : "none")};
  align-items: center;
  justify-content: center;

  width: ${(props) => toCssSize(props.size, 64)};
  height: ${(props) => toCssSize(props.size, 64)};

  background-color: ${(props) => props.backgroundColor || "transparent"};
  border-radius: 12px;

  > svg {
    display: block;
  }
`;